import { SortDirectionEnum, useInfiniteFindByQuery } from '../../graphql';
import { ISSUE_MESSAGE_FRAGMENT } from './issueMessageFragment';

export const ISSUE_MESSAGE_PAGE_COUNT = 20;

export const useFindIssueMessages = (issueId: string) => {
  return useInfiniteFindByQuery({
    modelName: 'issueMessage',
    query: FIND_ISSUE_MESSAGES,
    orderBy: {
      field: 'updatedAt',
      order: SortDirectionEnum.Desc,
    },
    // NOTE (Side Chat / plan 0022 §B): the main thread must exclude messages
    // that belong to a side chat (`parentMessage` set). We deliberately do NOT
    // add a server-side `parentMessage: { eq: null }` filter here: Graphback's
    // Mongo query builder crashes on a null relationship-id filter — `uuid-mongodb`
    // from() throws "Cannot read properties of null (reading _bsontype)" — which
    // would blank the ENTIRE main thread, not just side-chat rows (bd memory
    // 0014-revisionof-eq-null). The exclusion is therefore done client-side in
    // §C (issueMessages.tsx: `messages.filter(m => !m.parentMessage)` + the
    // subscription callback). `parentMessage { id }` is present on every row via
    // ISSUE_MESSAGE_FRAGMENT so that filter has the data it needs.
    filter: {
      issue: { eq: issueId },
    },
    pageSize: ISSUE_MESSAGE_PAGE_COUNT,
  });
};

const FIND_ISSUE_MESSAGES = `
  query findIssueMessages($filter: IssueMessageFilter, $page: PageRequest, $orderBy: OrderByInput) {
    findIssueMessages(filter: $filter, page: $page, orderBy: $orderBy) {
      items {
        ${ISSUE_MESSAGE_FRAGMENT}
        promptRoutine {
          id
          name
          currentVersion {
            id
          }
          type
          config
        }
      }
      count
      offset
      limit
    }
  }
`;
